import React from 'react';

interface LeaveBalanceProps {
  totalPaidLeave: number;
  totalTakenLeave: number;
  remainingPaidLeave: number;
  totalUnPaidLeave: number;
}

const LeaveBalance: React.FC<LeaveBalanceProps> = ({
  totalPaidLeave,
  totalTakenLeave,
  remainingPaidLeave,
  totalUnPaidLeave,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 h-20">
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h3 className="text-sm font-medium text-gray-500">Total Paid Leave</h3>
        <p className="text-2xl font-bold text-primary-2">{totalPaidLeave}</p>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h3 className="text-sm font-medium text-gray-500">Total Taken Leave</h3>
        <p className="text-2xl font-bold text-red-500">{totalTakenLeave}</p>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h3 className="text-sm font-medium text-gray-500">
          Remaining Paid Leave
        </h3>
        <p className="text-2xl font-bold text-green-500">
          {remainingPaidLeave}
        </p>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h3 className="text-sm font-medium text-gray-500">
          Total Unpaid Leave
        </h3>
        <p className="text-2xl font-bold text-yellow-500">{totalUnPaidLeave}</p>
      </div>
    </div>
  );
};

export default LeaveBalance;
